import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Monthlycorporatecabbooking() {



  const cardData =
  {
    keyword: 'Monthly Corporate Cab Bookings in Chennai',
    heading: 'Aaryan Travels: Monthly Corporate Cab Bookings in Chennai',
    headingDescription: 'Aaryan Travels offers reliable Monthly Corporate Cab Bookings in Chennai for IT companies, manufacturing units, and executives who require consistent and professional transportation services. Whether it’s daily office commute, client transport, airport pickups from Chennai International Airport, or intercity travel to Bengaluru or Pondicherry, our fleet of sedans, SUVs, and tempo travellers is available on structured monthly rental plans. With well-trained chauffeurs, GPS-enabled vehicles, on-time reporting, and hassle-free billing, we provide seamless mobility across key areas like OMR, Guindy, Ambattur, and Siruseri. Aaryan Travels ensures convenience and cost-efficiency with customized monthly corporate cab booking solutions in Chennai.',

    top: 'Top Places to Visit in Chennai with Aaryan Travels',

"topPlaces": [
  {
    "title": "Marina Beach",
    "description": "Marina Beach is India’s longest urban beach, stretching over 13 kilometers along the Bay of Bengal. It is a popular spot for sunrise views, evening strolls, and traditional snacks like sundal and murukku. Horse rides and kite flying add to the coastal charm. The lively promenade attracts locals and tourists alike. Marina Beach is Chennai’s iconic seaside escape."
  },
  {
    "title": "Kapaleeshwarar Temple",
    "description": "Located in Mylapore, Kapaleeshwarar Temple is a stunning Dravidian-style shrine dedicated to Lord Shiva. Its towering gopuram is adorned with colorful sculptures depicting Hindu mythology. Devotees gather in large numbers during festivals like Panguni Peruvizha. Surrounded by flower stalls and traditional shops, it exudes cultural vibrance. Kapaleeshwarar Temple is Chennai’s spiritual masterpiece."
  },
  {
    "title": "Fort St. George",
    "description": "Fort St. George, built in 1644 by the British East India Company, is the first English fortress in India. It now serves as the Tamil Nadu Legislative Assembly and houses a museum with colonial-era artifacts. St. Mary’s Church inside the fort is one of the oldest Anglican churches in Asia. Fort St. George is Chennai’s historical anchor of British heritage."
  },
  {
    "title": "Santhome Basilica",
    "description": "Santhome Basilica is a beautiful Gothic-style church built over the tomb of Saint Thomas the Apostle. Its serene interiors and stained-glass windows offer a peaceful ambiance. The underground chapel holds sacred relics of the saint. Located near the beach, it adds scenic charm. Santhome Basilica is Chennai’s sacred symbol of Christian legacy."
  },
  {
    "title": "Elliot’s Beach (Besant Nagar Beach)",
    "description": "Elliot’s Beach is a quieter alternative to Marina Beach, popular among youngsters and families. Visitors relax by the shore, enjoy seaside cafes, and take evening strolls. The Karl Schmidt Memorial and nearby Ashtalakshmi Temple add cultural appeal. Elliot’s Beach is Chennai’s calm and trendy coastal retreat."
  },
  {
    "title": "Valluvar Kottam",
    "description": "Valluvar Kottam is a monument dedicated to the renowned Tamil poet Thiruvalluvar. Built in the form of a temple chariot, it features inscriptions of all 1,330 couplets from the Thirukkural. The vast auditorium hosts cultural events and conferences. Valluvar Kottam is Chennai’s tribute to Tamil literature and wisdom."
  },
  {
    "title": "Government Museum, Egmore",
    "description": "The Government Museum in Egmore is one of India’s oldest museums, featuring archaeological finds, bronze idols, and zoological exhibits. The National Art Gallery inside showcases exquisite paintings and sculptures. The Indo-Saracenic architecture adds grandeur. It offers enriching experiences for all age groups. The museum is Chennai’s cultural reservoir of history."
  },
  {
    "title": "Guindy National Park",
    "description": "Guindy National Park is one of India’s smallest yet richest urban forests. It is home to blackbucks, spotted deer, jackals, and over 100 bird species. The adjoining Children’s Park and Snake Park make it ideal for families. Shaded paths offer a refreshing escape from city heat. Guindy Park is Chennai’s green lung of peace."
  },
  {
    "title": "Express Avenue Mall",
    "description": "Express Avenue Mall is a top shopping and entertainment hub with branded outlets, multiplex cinemas, and a large food court. The gaming zone is popular among youngsters. Its modern interiors and lively ambiance make it a favorite weekend hangout. Express Avenue is Chennai’s hotspot for fashion and fun."
  },
  {
    "title": "Arignar Anna Zoological Park (Vandalur Zoo)",
    "description": "Vandalur Zoo is India’s largest zoological park, spread across 1,500 acres. It houses tigers, lions, elephants, reptiles, and exotic birds. Safari rides and butterfly parks add adventure. The lush greenery and well-maintained enclosures make it ideal for full-day outings. Vandalur Zoo is Chennai’s wild world of exploration."
  }
],


"services": [
  {
    "name": "Monthly Corporate Cab Bookings in Chennai",
    "description": "Monthly Corporate Cab Bookings in Chennai offer reliable and cost-effective transportation solutions for companies seeking long-term employee and executive travel services. With dedicated chauffeur-driven vehicles available for an entire month, businesses benefit from fixed monthly pricing, consistent service quality, and reduced operational overhead. This service is ideal for daily office commutes, business meetings, and executive travel, ensuring timely pick-ups, professional drivers, and clean, well-maintained vehicles throughout the booking duration."
  },
  {
    "name": "Chennai Monthly Corporate Taxi",
    "description": "Chennai Monthly Corporate Taxi service delivers dependable taxi options for businesses on a recurring monthly basis. With professional chauffeurs and prompt support, companies can streamline transport logistics and focus on productivity."
  },
  {
    "name": "Corporate Cab Hire Chennai",
    "description": "Corporate Cab Hire Chennai is tailored for companies that require dedicated cab services for employee commutes, client visits, and executive transport. Vehicles are available with flexible plans and driven by trained chauffeurs."
  },
  {
    "name": "One Month Business Cab Chennai",
    "description": "One Month Business Cab Chennai provides companies with professional cab services for short-term monthly use. It's ideal for temporary staff transport, corporate events, or trial transport services before long-term contracts."
  },
  {
    "name": "Staff Transport Monthly Chennai",
    "description": "Staff Transport Monthly Chennai ensures your workforce arrives on time, every day. With fixed monthly pricing and experienced drivers, this service offers dependable transportation for your team across Chennai."
  },
  {
    "name": "Chauffeur Cab Chennai Monthly",
    "description": "Chauffeur Cab Chennai Monthly features courteous, uniformed drivers and premium cars for executive and corporate travel needs. It is perfect for VIPs, top management, or businesses seeking a high-end image."
  },
  {
    "name": "Long Term Corporate Cab Chennai",
    "description": "Long Term Corporate Cab Chennai offers flexible and extended corporate transportation plans, including monthly and quarterly rentals. This service supports staff transport, inter-office travel, and corporate mobility at scale."
  },
  {
    "name": "Office Cab Chennai Monthly",
    "description": "Office Cab Chennai Monthly ensures employees are transported safely and punctually every day. This service features fixed routes, trained drivers, and customizable schedules to match company shift timings."
  },
  {
    "name": "Affordable Corporate Cab Chennai",
    "description": "Affordable Corporate Cab Chennai delivers high-quality corporate transport at competitive rates. Ideal for startups, SMEs, and cost-conscious enterprises, it balances reliability with budget-friendly monthly packages."
  },
  {
    "name": "Premium Business Taxi Chennai",
    "description": "Premium Business Taxi Chennai caters to executives, clients, and business leaders who require upscale transportation with a focus on comfort and professionalism. High-end vehicles and discreet drivers define this service."
  },
  {
    "name": "Corporate Vehicle Hire Chennai",
    "description": "Corporate Vehicle Hire Chennai offers flexible hiring options for sedans, SUVs, and luxury cars for monthly use. Designed to meet varied business transport needs, vehicles come with professional drivers and full maintenance support."
  },
  {
    "name": "Chennai Corporate Taxi Plans",
    "description": "Chennai Corporate Taxi Plans provide scalable transportation packages for companies, including daily, weekly, and monthly bookings. This service offers transparent pricing, priority support, and a dedicated fleet."
  },
  {
    "name": "Monthly Chauffeur Services Chennai",
    "description": "Monthly Chauffeur Services Chennai delivers executive-class chauffeur-driven vehicles for long-term business travel. Professional drivers are trained in corporate etiquette, making this ideal for leadership teams and corporate guests."
  },
  {
    "name": "Business Cab Subscription Chennai",
    "description": "Business Cab Subscription Chennai allows companies to subscribe to recurring cab services for consistent and predictable travel management. It reduces the hassle of daily bookings and supports centralized transport tracking."
  },
  {
    "name": "Corporate Car Rental Chennai",
    "description": "Corporate Car Rental Chennai offers monthly rentals for a range of business-class vehicles, from sedans to SUVs. With customizable plans, businesses can ensure efficient mobility for teams and clients without vehicle ownership."
  }
],
"tableData": [
  ["Monthly Corporate Cab Bookings in Chennai", "Chennai Monthly Corporate Taxi"],
  ["Corporate Cab Hire Chennai", "One Month Business Cab Chennai"],
  ["Staff Transport Monthly Chennai", "Chauffeur Cab Chennai Monthly"],
  ["Long Term Corporate Cab Chennai", "Office Cab Chennai Monthly"],
  ["Affordable Corporate Cab Chennai", "Premium Business Taxi Chennai"],
  ["Corporate Vehicle Hire Chennai", "Chennai Corporate Taxi Plans"],
  ["Monthly Chauffeur Services Chennai", "Business Cab Subscription Chennai"],
  ["Corporate Car Rental Chennai", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "Monthly Corporate Cab Bookings in Chennai",
    "WhyChoosedescription": "Aaryan Travels offers reliable monthly corporate cab bookings in Chennai, designed to meet your business travel needs."
  },
  {
    "WhyChooseheading": "Punctual and Professional Drivers",
    "WhyChoosedescription": "Our experienced chauffeurs ensure timely pickups and drop-offs to keep your corporate schedule running smoothly."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs maintained for safety and comfort during your monthly rental."
  },
  {
    "WhyChooseheading": "Drivers Familiar with Chennai Routes",
    "WhyChoosedescription": "Our professional drivers know Chennai’s roads well, ensuring efficient and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy fixed monthly pricing inclusive of fuel, tolls, and driver allowances for worry-free billing."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Corporate Clients",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible and Customizable Plans",
    "WhyChoosedescription": "Choose plans tailored to your corporate travel requirements and vehicle preferences."
  },
  {
    "WhyChooseheading": "Dedicated Fleet for Corporate Clients",
    "WhyChoosedescription": "Benefit from priority service and dedicated vehicles assigned exclusively for your organization."
  }
]















  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer monthly corporate cab bookings in Chennai?',
    answer: 'Yes, Aaryan Travels provides flexible and reliable monthly corporate cab booking plans in Chennai tailored to meet your business travel needs.',
  },
  {
    question: 'How can I book monthly corporate cab bookings in Chennai with Aaryan Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 corporate customer support team.',
  },
  {
    question: 'What types of vehicles are available for monthly corporate cab bookings in Chennai?',
    answer: 'Aaryan Travels offers a range of well-maintained sedans, SUVs, and premium cars suited for corporate travel.',
  },
  {
    question: 'Are drivers experienced and trained for corporate cab bookings in Chennai?',
    answer: 'Absolutely. Our drivers are licensed, punctual, and professionally trained to provide safe and efficient service.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for monthly bookings?',
    answer: 'Yes, you can specify preferred pickup and drop-off points anywhere within Chennai and nearby business areas.',
  },
  {
    question: 'Is the monthly corporate cab booking service available 24x7 in Chennai?',
    answer: 'Yes, Aaryan Travels offers round-the-clock corporate cab booking services to meet your business schedules.',
  },
  {
    question: 'Are safety and hygiene protocols followed for monthly corporate cab bookings?',
    answer: 'All vehicles are sanitized regularly, and drivers adhere to strict safety and hygiene guidelines.',
  },
  {
    question: 'What payment options are accepted for monthly corporate cab bookings in Chennai?',
    answer: 'We accept payments via corporate accounts, UPI, digital wallets, credit/debit cards, and bank transfers.',
  },
  {
    question: 'Is customer support available during the monthly corporate cab booking period?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your booking period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arvind Kumar',
    feedback: 'Aaryan Travels made our monthly corporate cab bookings in Chennai smooth and hassle-free with excellent drivers.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavya Iyer',
    feedback: 'Reliable monthly corporate cab booking service by Aaryan Travels in Chennai. Highly recommend for business travel!',
    rating: 5,
  },
];


















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const monthlyCorporateCabBookingsChennaiSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Monthly Corporate Cab Bookings in Chennai",
  "description": "Aaryan Travels offers reliable monthly corporate cab bookings in Chennai, providing chauffeur-driven corporate taxis for staff transport, business trips, and office commute on long-term plans.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Chennai"
  },
  "serviceType": "Monthly Corporate Cab Booking",
  "keywords": "Monthly Corporate Cab Bookings in Chennai, Chennai Monthly Corporate Taxi, Corporate Cab Hire Chennai, One Month Business Cab Chennai, Staff Transport Monthly Chennai, Chauffeur Cab Chennai Monthly, Long Term Corporate Cab Chennai, Office Cab Chennai Monthly, Affordable Corporate Cab Chennai, Premium Business Taxi Chennai, Corporate Vehicle Hire Chennai, Chennai Corporate Taxi Plans, Monthly Chauffeur Services Chennai, Business Cab Subscription Chennai, Corporate Car Rental Chennai"
};






  return (
    <div>

<Helmet>
  <title>Monthly Corporate Cab Bookings in Chennai | Reliable Business Taxi Service | Aaryan Travels</title>
  <meta
    name="description"
    content="Book monthly corporate cab bookings in Chennai with Aaryan Travels. Affordable and premium chauffeur-driven corporate taxis for your business needs and staff transport."
  />
  <meta
    name="keywords"
    content="Monthly Corporate Cab Bookings in Chennai, Chennai Monthly Corporate Taxi, Corporate Cab Hire Chennai, One Month Business Cab Chennai, Staff Transport Monthly Chennai, Chauffeur Cab Chennai Monthly, Long Term Corporate Cab Chennai, Office Cab Chennai Monthly, Affordable Corporate Cab Chennai, Premium Business Taxi Chennai, Corporate Vehicle Hire Chennai, Chennai Corporate Taxi Plans, Monthly Chauffeur Services Chennai, Business Cab Subscription Chennai, Corporate Car Rental Chennai"
  />
  <script type="application/ld+json">
    {JSON.stringify(monthlyCorporateCabBookingsChennaiSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/70.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Monthlycorporatecabbooking;